export const kCaseTableTileType = "CaseTable"
export const kV2CaseTableType = "caseTable"
export const kCaseTableTileClass = "codap-case-table"
